function initNewsStandardPaging(totalPages, currentPage, pageUrl) {
    $('.pagination').pagination({
        pages: totalPages,
        cssStyle: 'light-theme',
        hrefTextPrefix: pageUrl + '?p=',
        currentPage: currentPage,
        hrefTextSuffix: '#newsArticles',

        onPageClick: function (pageNumber, event) {

        },
        onInit: function () {
        }
    });
}






var skip = 2;   // Always want to fetch the 2nd page of results on the first call as the first set is already visible


function fetchNextPageOfNews() {
    var prom = GetNewsPages();
    prom.then(
        function (result) {
            console.log("Search results : %o", result);
            skip += 1;  // Next page

            // Remove the old anchor then add a new one above the latest content
            $('#newsList').remove();
            result.markup = "<a name=\"newsList\" id=\"newsList\"></a>" + result.markup;

            $('.row.news-listing').append(result.markup);
            if (result.allPagesShowing) {
                $('.pagination').css('display', 'none');
            }
            scrollToAnchorID('newsList');
        }
    );
}


// Do our ajax call to fetch the results
function GetNewsPages() {
    return new Promise(function (resolve, reject) {

        var params = {
            numberToShow: articlesPerPage,
            skip: skip
        };

        console.log('GetNews : %o', params);
        $.ajax({
            url: "/Umbraco/Surface/NewsListing/GetPagedNews",
            method: 'post',
            data: params
        }).done(function (result) {
            resolve(result);
        }).fail(function (result) {
            console.log('Failed', result);
            reject(result);
        });
    });
}
